export default ({
  namespaced: true,
  state: {
    isForceLoading: false,
    isLoading: false,
    isNoneLoading: false,
    locale: 'ko-KR',
    layouts: {
      isHeader: false,
      titleName: '',
      isFooter: true,
      isMain: false,
      headerIconType: 0,
      isTab: false,
      tabType: 0,
      isMypage: false
    },
    modalAlert: {
      isShowAlert: false,
      isModalAlert: false,
      type: 0,
      data: {},
      callBack: null
    },
    modal: {
      isShow: false,
      isModal: false,
      modalName: '',
      modalTitle: '',
      isHideHeader: true,
      data: {},
      parent: {},
      callBack: () => {}
    },
    isShowModalAlert: false,
    isShowModal: false,
    isCloseModal: false,
    isSideBar: false,
    isHideHeader: false,
    isBack: true,
    isScroll: false,
    isOrderStatus: 1,
    isBannerFirst: true,
    isUptModal: false
  },
  getters: {
    getLayout (state) {
      return state.layouts
    },
    getLocale (state) {
      return state.locale
    },
    getLoading (state) {
      return state.isLoading
    },
    getIsCloseModal (state) {
      return state.isCloseModal
    },
    getModal (state) {
      return state.modal
    },
    getModalAlert (state) {
      return state.modalAlert
    },
    getIsShowModal (state) {
      return state.isShowModal
    },
    getIsShowModalAlert (state) {
      return state.isShowModalAlert
    },
    getIsSideBar (state) {
      return state.isSideBar
    },
    getIsHideHeader (state) {
      return state.isHideHeader
    },
    getIsScroll (state) {
      return state.isScroll
    },
    getIsOrderStatus (state) {
      return state.isOrderStatus
    },
    getIsBannerFirst (state) {
      return state.isBannerFirst
    },
    getIsUptModal (state) {
      return state.isUptModal
    },
  },
  mutations: {
    setIsForceLoading (state, {isForceLoading = false}) {
      state.isForceLoading = isForceLoading
    },
    setNoneLoading (state, {isNoneLoading = false}) {
      state.isNoneLoading = isNoneLoading
    },
    setLoading (state, {isLoading = false}) {
      state.isLoading = isLoading
    },
    setIsHideHeader (state, {isHideHeader = false}) {
      state.isHideHeader = isHideHeader
    },
    setLayout (state, {titleName = '', isHeader = true, isFooter = false, isMain = false, isTab = false, tabType = 0,  headerIconType = 0, isMypage = false}) {
      state.layouts.titleName = titleName
      state.layouts.isHeader = isHeader
      state.layouts.isFooter = isFooter
      state.layouts.isMain = isMain
      state.layouts.headerIconType = headerIconType
      state.layouts.isTab = isTab
      state.layouts.tabType = tabType
      state.layouts.isMypage = isMypage
    },
    setTitleName (state, {titleName = ''}) {
      state.layouts.titleName = titleName
    },
    setLocale (state, {locale = ''}) {
      state.locale = locale
    },
    setModal (state, {isModal = true, modalName = '', modalTitle = '', isHideHeader = true, data = {}, parent = {}, callBack = () => {}}) {
      let $data = {}
      $data['isModal'] = isModal
      $data['modalName'] = modalName
      $data['modalTitle'] = modalTitle
      $data['isHideHeader'] = isHideHeader
      $data['isShow'] = false
      $data['data'] = data
      $data['parent'] = parent
      $data['callBack'] = callBack
      state.modal = $data
    },
    // setModalAlert (state, {isModalAlert = true, modalAlertName = '', modalAlertTitle = '', isHideHeader = true, data = {}, parent = {}, callBack = () => {}, confirmLabel = '확인', cancelLabel = '취소'}) {
    //   let $data = {}
    //   $data['isModalAlert'] = isModalAlert
    //   $data['modalAlertName'] = modalAlertName
    //   $data['modalAlertTitle'] = modalAlertTitle
    //   $data['isHideHeader'] = isHideHeader
    //   $data['isShowAlert'] = false
    //   $data['data'] = data
    //   $data['parent'] = parent
    //   $data['callBack'] = callBack
    //   $data['confirmLabel'] = confirmLabel
    //   $data['cancelLabel'] = cancelLabel
    //   state.modalAlert = $data
    // },
    setModalAlert (state, {isModalAlert = true, type, data = {}, callBack = null}) {
      state.modalAlert.isModalAlert = isModalAlert
      state.modalAlert.type = type
      state.modalAlert.data = data
      state.modalAlert.callBack = callBack
    },
    setIsShowModal (state, {isShow = false}) {
      state.isShowModal = isShow
    },
    setIsShowModalAlert (state, {isShowAlert = false}) {
      state.isShowModalAlert = isShowAlert
    },
    setIsCloseModal (state, {isCloseModal = false}) {
      state.isCloseModal = isCloseModal
    },
    setIsSideBar (state, {isSideBar = false}) {
      state.isSideBar = isSideBar
    },
    setIsBack (state, {isBack = true}) {
      state.isBack = isBack
    },
    setIsScroll (state, {isScroll = false}) {
      state.isScroll = isScroll
    },
    setIsOrderStatus (state, {isOrderStatus = 0}) {
      state.isOrderStatus = isOrderStatus
    },
    setIsBannerFirst (state, {isBannerFirst = true}) {
      state.isBannerFirst = isBannerFirst
    },
    setIsUptModal (state, {isUptModal = false}) {
      state.isUptModal = isUptModal
    },
  }
})
